<template>
  <div>
    <div class="grid grid-cols-7 mb-1">
      <div v-for="day in weekDays" :key="day" class="text-center text-xs font-medium text-gray-500 dark:text-gray-400 py-2">
        {{ day }}
      </div>
    </div>
    <div class="grid grid-cols-7">
      <CalendarDay
        v-for="day in calendarDays"
        :key="day.date.toISOString()"
        :date="day.date"
        :posts="day.posts"
        :is-current-month="day.isCurrentMonth"
        :is-today="day.isToday"
        :campaign-colors="campaignColors"
        @drop="(postId, date) => $emit('drop', postId, date)"
        @click-post="(post) => $emit('click-post', post)"
        @click-day="(date) => $emit('click-day', date)" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import {
  startOfMonth, endOfMonth, startOfWeek, endOfWeek,
  eachDayOfInterval, isSameMonth, isToday, format
} from 'date-fns'
import CalendarDay from './calendar_day.vue'

const props = defineProps({
  currentMonth: { type: Date, required: true },
  posts: { type: Array, default: () => []},
  campaignColors: { type: Map, default: () => new Map() }
})

defineEmits(['drop', 'click-post', 'click-day'])

const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

const postsByDate = computed(() => {
  const map = new Map()
  props.posts.forEach((post) => {
    if (!post.scheduled_date) return
    const key = post.scheduled_date.substring(0, 10)
    if (!map.has(key)) map.set(key, [])
    map.get(key).push(post)
  })
  return map
})

const calendarDays = computed(() => {
  const monthStart = startOfMonth(props.currentMonth)
  const monthEnd = endOfMonth(props.currentMonth)
  const calStart = startOfWeek(monthStart)
  const calEnd = endOfWeek(monthEnd)

  return eachDayOfInterval({ start: calStart, end: calEnd }).map((date) => {
    const key = format(date, 'yyyy-MM-dd')
    return {
      date,
      isCurrentMonth: isSameMonth(date, props.currentMonth),
      isToday: isToday(date),
      posts: postsByDate.value.get(key) || []
    }
  })
})
</script>
